/*
 *
 * Results actions
 *
 */

import {
  SET_USER_INPUT,
  GET_JOBS,
  GET_JOBS_SUCCESS,
  GET_JOBS_ERROR,
  GET_PIPELINES,
  GET_PIPELINES_SUCCESS,
  GET_PIPELINES_ERROR,
  GET_CANDIDATES_BY_STATUS,
  GET_CANDIDATES_BY_STATUS_SUCCESS,
  GET_ALL_CANDIDATES_BY_STATUS_SUCCESS,
  GET_CANDIDATES_BY_STATUS_ERROR,
  CLEAR_CANDIDATES,
  GET_CANDIDATE_COUNTS,
  GET_CANDIDATE_COUNTS_SUCCESS,
  GET_CANDIDATE_COUNTS_ERROR,
  MOVE_CANDIDATES,
  OPTIMISTIC_MOVE_CANDIDATES,
  MOVE_CANDIDATES_SUCCESS,
  MOVE_CANDIDATES_ERROR,
  GET_CANDIDATE_SUMMARY,
  GET_CANDIDATE_SUMMARY_SUCCESS,
  GET_CANDIDATE_SUMMARY_ERROR,
  GET_TEST_REPORT,
  GET_TEST_REPORT_SUCCESS,
  GET_TEST_REPORT_ERROR,
  GET_RESUMES,
  GET_RESUMES_SUCCESS,
  GET_RESUMES_ERROR,
  GET_TIMELINE,
  GET_TIMELINE_SUCCESS,
  GET_TIMELINE_ERROR,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_APPLICATION_ERROR,
  GET_APPLICATIONS_DATA,
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_ERROR,
  GET_LABELS,
  GET_LABELS_SUCCESS,
  GET_LABELS_ERROR,
  CREATE_LABEL,
  CREATE_LABEL_SUCCESS,
  CREATE_LABEL_ERROR,
  ADD_LABEL,
  DELETE_ADDED_LABEL,
  CLEAR_ADDED_LABELS,
  LABELS_TO_CANDIDATES,
  OPTIMISTIC_LABELS_TO_CANDIDATES,
  LABELS_TO_CANDIDATES_SUCCESS,
  LABELS_TO_CANDIDATES_ERROR,
  SHARE_RESULTS,
  SHARE_RESULTS_SUCCESS,
  SHARE_RESULTS_ERROR,
  CLOSE_SHARE_RESULTS_CONFIRMATION_MODAL,
  DOWNLOAD_RESULTS,
  DOWNLOAD_RESULTS_SUCCESS,
  DOWNLOAD_RESULTS_ERROR,
  DOWNLOAD_RESULTS_SINGLE,
  DOWNLOAD_RESULTS_SINGLE_SUCCESS,
  DOWNLOAD_RESULTS_SINGLE_ERROR,
  EMAIL_CANDIDATES,
  EMAIL_CANDIDATES_SUCCESS,
  EMAIL_CANDIDATES_ERROR,
  LOAD_SAVED_EMAIL_TEMPLATES,
  LOAD_SAVED_EMAIL_TEMPLATES_SUCCESS,
  LOAD_SAVED_EMAIL_TEMPLATES_ERROR,
  RESCHEDULE_TESTS,
  RESCHEDULE_TESTS_SUCCESS,
  RESCHEDULE_TESTS_ERROR,
  RESET_SCHEDULE_STATUS,
  GET_TEST_BATTERIES,
  GET_TEST_BATTERIES_SUCCESS,
  GET_TEST_BATTERIES_ERROR,
  GET_TM_SCORERANGES,
  GET_TM_SCORERANGES_SUCCESS,
  GET_TM_SCORERANGES_ERROR,
  GET_CANDIDATE_RATINGS,
  GET_CANDIDATE_RATINGS_SUCCESS,
  GET_CANDIDATE_RATINGS_ERROR,
  RATE_CANDIDATE,
  RATE_CANDIDATE_SUCCESS,
  RATE_CANDIDATE_ERROR,
  EDIT_CANDIDATE_RATING,
  EDIT_CANDIDATE_RATING_SUCCESS,
  EDIT_CANDIDATE_RATING_ERROR,
  GET_JOB_RATING,
  GET_JOB_RATING_SUCCESS,
  GET_JOB_RATING_ERROR,
  GET_AVG_RATING,
  GET_AVG_RATING_SUCCESS,
  GET_AVG_RATING_ERROR,
  POST_NOTE,
  POST_NOTE_SUCCESS,
  POST_NOTE_ERROR,
  EDIT_NOTE,
  EDIT_NOTE_SUCCESS,
  EDIT_NOTE_ERROR,
  DELETE_NOTE,
  DELETE_NOTE_SUCCESS,
  DELETE_NOTE_ERROR,
  UPLOAD_RESUME,
  UPLOAD_RESUME_SUCCESS,
  UPLOAD_RESUME_ERROR,
  INVITE_CANDIDATE,
  INVITE_CANDIDATE_SUCCESS,
  INVITE_CANDIDATE_ERROR,
  DELETE_TEST_EVENT,
  DELETE_TEST_EVENT_SUCCESS,
  DELETE_TEST_EVENT_ERROR,
  RESET_DELETE_TEST_EVENT_SUCCESS,
  RESET_LOADED_PROPS,
  GET_USERS_AND_TEAMS,
  GET_USERS_AND_TEAMS_SUCCESS,
  GET_USERS_AND_TEAMS_ERROR,
  RELEASE_SCORES,
  RELEASE_SCORES_SUCCESS,
  RELEASE_SCORES_ERROR,
  GET_FILTERS,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_ERROR,
  GET_CHECKR_PACKAGES,
  GET_CHECKR_PACKAGES_SUCCESS,
  GET_CHECKR_PACKAGES_ERROR,
  CHECKR_INVITE_CANDIDATE,
  CHECKR_INVITE_CANDIDATE_SUCCESS,
  CHECKR_INVITE_CANDIDATE_ERROR,
  GET_CHECKR_INFO,
  GET_CHECKR_INFO_SUCCESS,
  GET_CHECKR_INFO_ERROR,
  SET_CANDIDATE_FOUND,
  LOAD_TESTMAKER_TESTS,
  LOAD_TESTMAKER_TESTS_SUCCESS,
  LOAD_TESTMAKER_TESTS_ERROR,
  DOWNLOAD_RESUME,
  DOWNLOAD_RESUME_SUCCESS,
  DOWNLOAD_RESUME_ERROR,
  LOAD_SCORE_RANGES,
  LOAD_SCORE_RANGES_SUCCESS,
  LOAD_SCORE_RANGES_ERROR,
  MOVE_CANDIDATES_TO_JOB,
  MOVE_CANDIDATES_TO_JOB_SUCCESS,
  MOVE_CANDIDATES_TO_JOB_ERROR,
  COPY_CANDIDATES_TO_JOB,
  COPY_CANDIDATES_TO_JOB_SUCCESS,
  COPY_CANDIDATES_TO_JOB_ERROR,
  FLIP_CANDIDATE_PRIVACY,
  FLIP_CANDIDATE_PRIVACY_SUCCESS,
  FLIP_CANDIDATE_PRIVACY_ERROR,
  GET_PIPELINE_BY_ID,
  GET_PIPELINE_BY_ID_SUCCESS,
  GET_PIPELINE_BY_ID_ERROR,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_ERROR,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_ERROR,
  GET_DOCUMENT_LINK,
  GET_DOCUMENT_LINK_SUCCESS,
  GET_DOCUMENT_LINK_ERROR,
  REMIND_CANDIDATE,
  REMIND_CANDIDATE_SUCCESS,
  REMIND_CANDIDATE_ERROR,
  DELETE_INVITATIONS,
  DELETE_INVITATIONS_ERROR,
  DELETE_INVITATIONS_SUCCESS,
  GET_WORKPLACE_INSIGHTS,
  GET_WORKPLACE_INSIGHTS_SUCCESS,
  GET_WORKPLACE_INSIGHTS_ERROR,
  CLEAR_WORKPLACE_INSIGHTS,
  GET_WORKPLACE_EMAIL_PREVIEW,
  GET_WORKPLACE_EMAIL_PREVIEW_SUCCESS,
  GET_WORKPLACE_EMAIL_PREVIEW_ERROR,
  CLEAR_WORKPLACE_EMAIL_PREVIEW,
  SEND_WORKPLACE_INSIGHTS_EMAIL,
  SEND_WORKPLACE_INSIGHTS_EMAIL_SUCCESS,
  SEND_WORKPLACE_INSIGHTS_EMAIL_ERROR,
  GET_WORK_STYLES,
  GET_WORK_STYLES_SUCCESS,
  GET_WORK_STYLES_ERROR,
  CLEAR_WORK_STYLES,
  GET_CANDIDATE_BY_ID,
  GET_CANDIDATE_BY_ID_SUCCESS,
  GET_CANDIDATE_BY_ID_ERROR,
  EDIT_CANDIDATE,
  EDIT_CANDIDATE_SUCCESS,
  EDIT_CANDIDATE_ERROR,
  EXTEND_EVENT_EXPIRATION,
  EXTEND_EVENT_EXPIRATION_SUCCESS,
  EXTEND_EVENT_EXPIRATION_ERROR,
  RESET_CANDIDATE_SUMMARIES,
  UPDATE_CANDIDATES_AFTER_DELETE,
  GET_VIDEO_INTERVIEWS_RESULT,
  GET_VIDEO_INTERVIEWS_RESULT_SUCCESS,
  GET_VIDEO_INTERVIEWS_RESULT_ERROR,
  GET_VIDEO_INTERVIEW_TEMPLATES,
  GET_VIDEO_INTERVIEW_TEMPLATES_SUCCESS,
  GET_VIDEO_INTERVIEW_TEMPLATES_ERROR,
  GET_JOB_BY_ID,
  GET_JOB_BY_ID_ERROR,
  GET_JOB_BY_ID_SUCCESS,
  RESCHEDULE_VIDEO_INTERVIEW,
  RESCHEDULE_VIDEO_INTERVIEW_SUCCESS,
  RESCHEDULE_VIDEO_INTERVIEW_ERROR,
  CHANGE_SORT_CRITERIA,
  GET_JOB_RESULTS_CUSTOMIZATION,
  GET_JOB_RESULTS_CUSTOMIZATION_SUCCESS,
  GET_JOB_RESULTS_CUSTOMIZATION_ERROR,
  UPDATE_JOB_RESULTS_CUSTOMIZATIONS,
  UPDATE_JOB_RESULTS_CUSTOMIZATIONS_SUCCESS,
  UPDATE_JOB_RESULTS_CUSTOMIZATIONS_ERROR,
  SHOW_RESULTS_V2_BULK_ACTION_MODAL,
  REVERT_RESULTS_CUSTOMIZATIONS,
  REVERT_RESULTS_CUSTOMIZATIONS_SUCCESS,
  REVERT_RESULTS_CUSTOMIZATIONS_ERROR,
  GET_CANDIDATE_SI_REPORT,
  GET_CANDIDATE_SI_REPORT_ERROR,
  SET_CURRENT_STAGE_ID,
  RESET_MOVE_CANDIDATES_STATUS,
  GET_LIVE_INTERVIEWS_RESULT,
  GET_LIVE_INTERVIEWS_RESULT_SUCCESS,
  GET_LIVE_INTERVIEWS_RESULT_ERROR,
  SEND_EVALUATORS_EMAIL,
  SEND_EVALUATORS_EMAIL_SUCCESS,
  SEND_EVALUATORS_EMAIL_ERROR,
  RESET_SEND_EVALUATORS_EMAIL_STATUS,
  SEND_INDIVIDUAL_EVALUATOR_EMAIL,
  SEND_INDIVIDUAL_EVALUATOR_EMAIL_SUCCESS,
  SEND_INDIVIDUAL_EVALUATOR_EMAIL_ERROR,
  GET_DYNAMIC_SCORE_REPORTS_DATA,
  GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS,
  GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR,
  REMOVE_MERCH_BANNER,
  REMOVE_MERCH_BANNER_SUCCESS,
  REMOVE_MERCH_BANNER_ERROR,
  GET_MANAGER_GUIDE,
  GET_MANAGER_GUIDE_SUCCESS,
  GET_MANAGER_GUIDE_ERROR,
  GET_MANAGER_GUIDE_REPORT,
  GET_MANAGER_GUIDE_REPORT_SUCCESS,
  GET_MANAGER_GUIDE_REPORT_ERROR,
  MOVE_CANDIDATE_TO_POST_HIRE,
  MOVE_CANDIDATE_TO_POST_HIRE_SUCCESS,
  MOVE_CANDIDATE_TO_POST_HIRE_ERROR,
  GET_POST_HIRE_USERS,
  GET_POST_HIRE_USERS_SUCCESS,
  GET_POST_HIRE_USERS_ERROR,
  CHECK_FOR_VALID_POST_HIRE_EMAIL,
  CHECK_FOR_VALID_POST_HIRE_EMAIL_SUCCESS,
  CHECK_FOR_VALID_POST_HIRE_EMAIL_ERROR,
  GET_POST_HIRE_TEST_TAKERS,
  GET_POST_HIRE_TEST_TAKERS_SUCCESS,
  GET_POST_HIRE_TEST_TAKERS_ERROR,
  RESET_MOVE_CANDIDATE_TO_POST_HIRE_STATUS,
  EDIT_VIDEO_INTERVIEW_ADJUSTMENTS,
  EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_SUCCESS,
  EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_ERROR,
  GET_ALL_POSTHIRE_TEAMS,
  GET_ALL_POSTHIRE_TEAMS_SUCCESS,
  GET_ALL_POSTHIRE_TEAMS_ERROR,
  GET_TEAM_PERSONALITY_SCORES_BY_ID,
  GET_TEAM_PERSONALITY_SCORES_BY_ID_SUCCESS,
  GET_TEAM_PERSONALITY_SCORES_BY_ID_ERROR,
  GET_SMART_ONBOARDING_KEY_INSIGHTS,
  GET_SMART_ONBOARDING_KEY_INSIGHTS_SUCCESS,
  GET_SMART_ONBOARDING_KEY_INSIGHTS_ERROR,
  RESET_SMART_ONBOARDING_KEY_INSIGHTS,
  GET_LANDING_PAGE_SUCCESS,
  GET_LANDING_PAGE,
  GET_LANDING_PAGE_ERROR,
  GET_PROCTORING_REPORT,
  GET_PROCTORING_REPORT_SUCCESS,
  GET_PROCTORING_REPORT_ERROR,
  UPDATE_DOWNLOAD_STATUS,
} from "./constants";

export function setUserInput(field, value) {
  return {
    type: SET_USER_INPUT,
    field,
    value,
  };
}

// --------- jobs ---------
export function getJobs() {
  return {
    type: GET_JOBS,
  };
}
export function getJobsSuccess(jobs) {
  return {
    type: GET_JOBS_SUCCESS,
    data: jobs,
  };
}
export function getJobsError(error) {
  return {
    type: GET_JOBS_ERROR,
    data: error,
  };
}

// --------- pipelines ---------
export function getPipelines() {
  return {
    type: GET_PIPELINES,
  };
}
export function getPipelinesSuccess(pipelines) {
  return {
    type: GET_PIPELINES_SUCCESS,
    data: pipelines,
  };
}
export function getPipelinesError(error) {
  return {
    type: GET_PIPELINES_ERROR,
    data: error,
  };
}

/* ---------- Get candidates by status ---------- */

export function getCandidatesByStatus(
  pipelineStageMapId,
  status,
  jobDetailId,
  offset,
  isCurrentStageVideoInterviewStage,
  resultsV2,
  testTakerId = null // TODO: add this to the get call, when looking for a specific candidate,
) {
  return {
    type: GET_CANDIDATES_BY_STATUS,
    data: {
      pipelineStageMapId, // notHired = 0, all = -1
      status,
      customizableResults: resultsV2,
    },
    jobDetailId,
    offset,
    isCurrentStageVideoInterviewStage,
    resultsV2,
    testTakerId,
  };
}
export function getCandidatesByStatusSuccess(
  candidates,
  stageId,
  allCandidatesLoaded,
  status,
  isFirstBatch
) {
  return {
    type: GET_CANDIDATES_BY_STATUS_SUCCESS,
    candidates,
    stageId,
    allCandidatesLoaded,
    status,
    isFirstBatch,
  };
}
export function getAllCandidatesByStatusSuccess(
  candidates,
  allCandidatesLoaded,
  status,
  stageId,
  isFirstBatch
) {
  return {
    type: GET_ALL_CANDIDATES_BY_STATUS_SUCCESS,
    candidates,
    allCandidatesLoaded,
    status,
    stageId,
    isFirstBatch,
  };
}
export function getCandidatesByStatusError(err) {
  return {
    type: GET_CANDIDATES_BY_STATUS_ERROR,
    err,
  };
}

// --------- clear candidates when switching jobs ---------
export function clearCandidates() {
  return {
    type: CLEAR_CANDIDATES,
  };
}

// --------- candidate counts ---------
export function getCandidateCounts(jobId) {
  return {
    type: GET_CANDIDATE_COUNTS,
    jobId,
  };
}
export function getCandidateCountsSuccess(counts) {
  return {
    type: GET_CANDIDATE_COUNTS_SUCCESS,
    counts,
  };
}
export function getCandidateCountsError(error) {
  return {
    type: GET_CANDIDATE_COUNTS_ERROR,
    data: error,
  };
}

// --------- move candidates ---------
export function moveCandidates(
  stageId,
  candidateIds,
  candidateNames,
  stageName,
  prevStage,
  jobId,
  fromResultsV2,
  isLiveInterviewStage
) {
  return {
    type: MOVE_CANDIDATES,
    data: {
      pipelineStageMapId: stageId,
      testTakerIds: candidateIds,
      candidateNames,
      stageName,
      prevStage,
      jobDetailId: jobId,
      customizableResults: fromResultsV2,
      isLiveInterviewStage,
    },
  };
}
export function optimisticMoveCandidates(
  nextStage,
  prevStage,
  candidateIds,
  currentStageId,
  isUndoAction,
  currentPipeline
) {
  return {
    type: OPTIMISTIC_MOVE_CANDIDATES,
    data: {
      nextStage,
      prevStage,
      candidateIds,
      currentStageId,
      isUndoAction,
      currentPipeline,
    },
  };
}
export function moveCandidatesSuccess(data, isLiveInterviewStage) {
  return {
    type: MOVE_CANDIDATES_SUCCESS,
    candidates: data.candidates,
    testEventIds: data.testEventIds,
    isLiveInterviewStage,
  };
}
export function moveCandidatesError(error) {
  return {
    type: MOVE_CANDIDATES_ERROR,
    data: error,
  };
}

// --------- candidate summary ---------
export function getCandidateSummary(candidateId, format = "html") {
  return {
    type: GET_CANDIDATE_SUMMARY,
    data: { testTakerId: candidateId },
    format,
  };
}
export function getCandidateSummarySuccess(data) {
  return {
    type: GET_CANDIDATE_SUMMARY_SUCCESS,
    data,
  };
}
export function getCandidateSummaryError(error) {
  return {
    type: GET_CANDIDATE_SUMMARY_ERROR,
    data: error,
  };
}

// --------- manager guide ---------
export function getManagerGuideReport(candidateId) {
  return {
    type: GET_MANAGER_GUIDE_REPORT,
    data: { testTakerId: candidateId },
  };
}
export function getManagerGuideReportSuccess(data) {
  return {
    type: GET_MANAGER_GUIDE_REPORT_SUCCESS,
    data,
  };
}
export function getManagerGuideReportError(error) {
  return {
    type: GET_MANAGER_GUIDE_REPORT_ERROR,
    data: error,
  };
}

// --------- test reports ---------
export function getTestReport(
  candidateId,
  testEventId,
  testId,
  isTestMaker,
  format = "html", // eslint-disable-line default-param-last
  testName,
  csapSalesAP,
  positionName
) {
  return {
    type: GET_TEST_REPORT,
    candidateId,
    testEventId,
    testId,
    isTestMaker,
    format,
    testName,
    csapSalesAP,
    positionName,
  };
}
export function getTestReportSuccess(candidateId, report, testEventTestId) {
  return {
    type: GET_TEST_REPORT_SUCCESS,
    data: { candidateId, report, testEventTestId },
  };
}
export function getTestReportError(error) {
  return {
    type: GET_TEST_REPORT_ERROR,
    data: error,
  };
}

// --------- resumes ---------
export function getResumes(candidateIds) {
  return {
    type: GET_RESUMES,
    candidateIds,
  };
}
export function getResumesSuccess(candidateIds, resumesResponse) {
  return {
    type: GET_RESUMES_SUCCESS,
    candidateIds,
    resumesResponse,
  };
}
export function getResumesError(error) {
  return {
    type: GET_RESUMES_ERROR,
    data: error,
  };
}

// --------- timelines ---------
export function getTimeline(candidateId) {
  return {
    type: GET_TIMELINE,
    candidateId,
  };
}
export function getTimelineSuccess(candidateId, timelineResponse) {
  return {
    type: GET_TIMELINE_SUCCESS,
    candidateId,
    timeline: timelineResponse,
  };
}
export function getTimelineError(error) {
  return {
    type: GET_TIMELINE_ERROR,
    data: error,
  };
}

// --------- applications ---------
export function getApplication(candidateId, format = "html") {
  return {
    type: GET_APPLICATION,
    candidateId,
    format,
  };
}
export function getApplicationSuccess(candidateId, applicationResponse) {
  return {
    type: GET_APPLICATION_SUCCESS,
    candidateId,
    applicationResponse,
  };
}
export function getApplicationError(error) {
  return {
    type: GET_APPLICATION_ERROR,
    data: error,
  };
}

// --------- applications data for export ---------
export function getApplicationsData(
  testTakerIds,
  allCandidates,
  jobName,
  pipeline,
  externalIdOn
) {
  return {
    type: GET_APPLICATIONS_DATA,
    testTakerIds: { testTakerIds },
    allCandidates,
    jobName,
    pipeline,
    externalIdOn,
  };
}

// --------- get candidate documents ---------
export function getDocuments(testTakerId) {
  return {
    type: GET_DOCUMENTS,
    testTakerId,
  };
}
export function getDocumentsSuccess(testTakerId, documentsResponse) {
  return {
    type: GET_DOCUMENTS_SUCCESS,
    testTakerId,
    documentsResponse,
  };
}
export function getDocumentsError(error) {
  return {
    type: GET_DOCUMENTS_ERROR,
    data: error,
  };
}

// --------- labels ---------
export function getLabels() {
  return {
    type: GET_LABELS,
  };
}
export function getLabelsSuccess(labelsResponse) {
  return {
    type: GET_LABELS_SUCCESS,
    data: labelsResponse,
  };
}
export function getLabelsError(error) {
  return {
    type: GET_LABELS_ERROR,
    data: error,
  };
}

export function createLabel(labelName, labelId) {
  return {
    type: CREATE_LABEL,
    data: { labelName },
    labelId,
  };
}
export function createLabelSuccess(labelResponse) {
  return {
    type: CREATE_LABEL_SUCCESS,
    data: labelResponse,
  };
}
export function createLabelError(error) {
  return {
    type: CREATE_LABEL_ERROR,
    data: error,
  };
}

export function addLabel(labelId, labelName) {
  return {
    type: ADD_LABEL,
    labelId,
    labelName,
  };
}
export function deleteAddedLabel(labelId) {
  return {
    type: DELETE_ADDED_LABEL,
    labelId,
  };
}
export function clearAddedLabels() {
  return {
    type: CLEAR_ADDED_LABELS,
  };
}

export function labelsToCandidates(
  testTakerIds,
  labelIdsToDelete,
  labelIdsToAdd
) {
  return {
    type: LABELS_TO_CANDIDATES,
    data: { testTakerIds, labelIdsToDelete, labelIdsToAdd },
  };
}
export function optimisticLabelsToCandidates(
  testTakerIds,
  labelIdsToDelete,
  labelsToAdd,
  candidateIdsStageMap
) {
  return {
    type: OPTIMISTIC_LABELS_TO_CANDIDATES,
    data: { testTakerIds, labelIdsToDelete, labelsToAdd, candidateIdsStageMap },
  };
}
export function labelsToCandidatesSuccess(labelsToCandidatesResponse) {
  return {
    type: LABELS_TO_CANDIDATES_SUCCESS,
    data: labelsToCandidatesResponse,
  };
}
export function labelsToCandidatesError(error) {
  return {
    type: LABELS_TO_CANDIDATES_ERROR,
    data: error,
  };
}

// --------- share results ---------
export function shareResults(shareDataObj) {
  return {
    type: SHARE_RESULTS,
    shareDataObj,
  };
}
export function shareResultsSuccess(shareResponse) {
  return {
    type: SHARE_RESULTS_SUCCESS,
    shareResponse,
  };
}
export function shareResultsError(error) {
  return {
    type: SHARE_RESULTS_ERROR,
    data: error,
  };
}

// --------- close share results confirmation modal ---------
export function closeShareResultsConfirmationModal() {
  return {
    type: CLOSE_SHARE_RESULTS_CONFIRMATION_MODAL,
  };
}

// --------- download results ---------
export function downloadResults(dataObj) {
  //  Required: testTakerIds (array) Required: options {report: t/f, summary: t/f}
  return {
    type: DOWNLOAD_RESULTS,
    data: dataObj,
  };
}
export function downloadResultsSuccess(downloadResponse) {
  return {
    type: DOWNLOAD_RESULTS_SUCCESS,
    downloadResponse,
  };
}
export function downloadResultsError(error) {
  return {
    type: DOWNLOAD_RESULTS_ERROR,
    data: error,
  };
}

// --------- download results single PDF ---------
export function downloadResultsSingle(testTakerId, candidateInfo) {
  return {
    type: DOWNLOAD_RESULTS_SINGLE,
    testTakerId,
    candidateInfo,
  };
}
export function downloadResultsSingleSuccess() {
  return {
    type: DOWNLOAD_RESULTS_SINGLE_SUCCESS,
  };
}
export function downloadResultsSingleError(error) {
  return {
    type: DOWNLOAD_RESULTS_SINGLE_ERROR,
    data: error,
  };
}

// --------- email candidates ---------
export function emailCandidates(dataObj) {
  // {emailTemplateId: '', testTakerIds: []}
  return {
    type: EMAIL_CANDIDATES,
    data: dataObj,
  };
}
export function emailCandidatesSuccess(emailCandidatesResponse) {
  return {
    type: EMAIL_CANDIDATES_SUCCESS,
    emailCandidatesResponse,
  };
}
export function emailCandidatesError(error) {
  return {
    type: EMAIL_CANDIDATES_ERROR,
    data: error,
  };
}

// --------- load email templates ---------
export function loadSavedEmailTemplates() {
  return {
    type: LOAD_SAVED_EMAIL_TEMPLATES,
  };
}
export function loadSavedEmailTemplatesSuccess(templates) {
  const templatesObj = {};
  templates.forEach((template) => {
    templatesObj[template.emailTemplateId] = template;
  });
  return {
    type: LOAD_SAVED_EMAIL_TEMPLATES_SUCCESS,
    data: templatesObj,
  };
}
export function loadSavedEmailTemplatesError(error) {
  return {
    type: LOAD_SAVED_EMAIL_TEMPLATES_ERROR,
    data: error,
  };
}

// --------- reschedule candidate tests ---------
export function rescheduleTests(dataObj, jobId, candidateName, externalIdOn) {
  return {
    type: RESCHEDULE_TESTS,
    data: dataObj,
    jobId,
    candidateName,
    externalIdOn,
  };
}
export function rescheduleTestsSuccess(
  rescheduleCandidatesResponse,
  testTakerIds,
  supervised,
  externalIdOn
) {
  return {
    type: RESCHEDULE_TESTS_SUCCESS,
    rescheduleCandidatesResponse,
    testTakerIds,
    supervised,
    externalIdOn,
  };
}
export function rescheduleTestsError(error) {
  return {
    type: RESCHEDULE_TESTS_ERROR,
    data: error,
  };
}

/* ----------- Rest Scheduled Status ----------- */

export function resetScheduledStatus() {
  return {
    type: RESET_SCHEDULE_STATUS,
  };
}

// --------- get test batteries ---------
export function getTestBatteries() {
  return {
    type: GET_TEST_BATTERIES,
  };
}
export function getTestBatteriesSuccess(testBatteriesResponse) {
  return {
    type: GET_TEST_BATTERIES_SUCCESS,
    data: testBatteriesResponse,
  };
}
export function getTestBatteriesError(error) {
  return {
    type: GET_TEST_BATTERIES_ERROR,
    data: error,
  };
}

// --------- get testMaker score ranges ---------
export function getTMScoreRanges(tmIds) {
  return {
    type: GET_TM_SCORERANGES,
    data: { testMakerTestIds: tmIds },
  };
}
export function getTMScoreRangesSuccess(tmScoreRangesResponse) {
  return {
    type: GET_TM_SCORERANGES_SUCCESS,
    data: tmScoreRangesResponse,
  };
}
export function getTMScoreRangesError(error) {
  return {
    type: GET_TM_SCORERANGES_ERROR,
    data: error,
  };
}

// --------- ratings actions ---------
export function getCandidateRatings(testTakerId) {
  return {
    type: GET_CANDIDATE_RATINGS,
    testTakerId,
  };
}
export function getCandidateRatingsSuccess(
  candidateRatingsResponse,
  testTakerId
) {
  return {
    type: GET_CANDIDATE_RATINGS_SUCCESS,
    candidateRatingsResponse,
    testTakerId,
  };
}
export function getCandidateRatingsError(error) {
  return {
    type: GET_CANDIDATE_RATINGS_ERROR,
    data: error,
  };
}
export function rateCandidate(ratingData, stageId) {
  return {
    type: RATE_CANDIDATE,
    data: ratingData,
    stageId,
  };
}
export function rateCandidateSuccess(testTakerId, stageId) {
  return {
    type: RATE_CANDIDATE_SUCCESS,
    testTakerId,
    stageId,
  };
}
export function rateCandidateError(error) {
  return {
    type: RATE_CANDIDATE_ERROR,
    data: error,
  };
}
export function editCandidateRating(ratingData, stageId) {
  return {
    type: EDIT_CANDIDATE_RATING,
    data: ratingData,
    stageId,
  };
}
export function editCandidateRatingSuccess() {
  return {
    type: EDIT_CANDIDATE_RATING_SUCCESS,
  };
}
export function editCandidateRatingError(error) {
  return {
    type: EDIT_CANDIDATE_RATING_ERROR,
    data: error,
  };
}
export function getJobRating(jobDetailId) {
  return {
    type: GET_JOB_RATING,
    jobDetailId,
  };
}
export function getJobRatingSuccess(getJobRatingResponse, jobDetailId) {
  return {
    type: GET_JOB_RATING_SUCCESS,
    getJobRatingResponse,
    jobDetailId,
  };
}
export function getJobRatingError(error) {
  return {
    type: GET_JOB_RATING_ERROR,
    data: error,
  };
}

export function getAvgRating(testTakerId, stageId) {
  return {
    type: GET_AVG_RATING,
    testTakerId,
    stageId,
  };
}
export function getAvgRatingSuccess(
  getAvgRatingResponse,
  testTakerId,
  stageId
) {
  return {
    type: GET_AVG_RATING_SUCCESS,
    getAvgRatingResponse,
    testTakerId,
    stageId,
  };
}
export function getAvgRatingError(error) {
  return {
    type: GET_AVG_RATING_ERROR,
    data: error,
  };
}

export function getUsersAndTeams() {
  return {
    type: GET_USERS_AND_TEAMS,
  };
}
export function getUsersAndTeamsSuccess(allUsers, users, teams) {
  return {
    type: GET_USERS_AND_TEAMS_SUCCESS,
    allUsers,
    users,
    teams,
  };
}
export function getUsersAndTeamsError(error) {
  return {
    type: GET_USERS_AND_TEAMS_ERROR,
    error,
  };
}

export function postNote(note, testTakerId, stageId) {
  return {
    type: POST_NOTE,
    data: { note, testTakerId },
    stageId,
  };
}
export function postNoteSuccess(postNoteResponse, testTakerId, stageId) {
  return {
    type: POST_NOTE_SUCCESS,
    postNoteResponse,
    testTakerId,
    stageId,
  };
}
export function postNoteError(error) {
  return {
    type: POST_NOTE_ERROR,
    data: error,
  };
}

export function editNote(note, noteId, testTakerId) {
  return {
    type: EDIT_NOTE,
    noteId,
    testTakerId,
    data: { note },
  };
}
export function editNoteSuccess(note, noteId, testTakerId) {
  return {
    type: EDIT_NOTE_SUCCESS,
    note,
    testTakerId,
    noteId,
  };
}
export function editNoteError(error) {
  return {
    type: EDIT_NOTE_ERROR,
    data: error,
  };
}

export function deleteNote(noteId, testTakerId, stageId, lastNote) {
  return {
    type: DELETE_NOTE,
    noteId,
    testTakerId,
    stageId,
    lastNote,
  };
}
export function deleteNoteSuccess(noteId, testTakerId, stageId, lastNote) {
  return {
    type: DELETE_NOTE_SUCCESS,
    testTakerId,
    noteId,
    stageId,
    lastNote,
  };
}
export function deleteNoteError(error) {
  return {
    type: DELETE_NOTE_ERROR,
    data: error,
  };
}

export function uploadResume(base64Resume, fileName, testTakerId, stageId) {
  return {
    type: UPLOAD_RESUME,
    testTakerId,
    stageId,
    data: { resumeData: base64Resume, fileName },
  };
}
export function uploadResumeSuccess(
  uploadResumeResponse,
  testTakerId,
  stageId
) {
  return {
    type: UPLOAD_RESUME_SUCCESS,
    uploadResumeResponse,
    testTakerId,
    stageId,
  };
}
export function uploadResumeError(error) {
  return {
    type: UPLOAD_RESUME_ERROR,
    data: error,
  };
}

export function inviteCandidate(testEventId, candidateName) {
  return {
    type: INVITE_CANDIDATE,
    data: { testEventId },
    candidateName,
  };
}
export function inviteCandidateSuccess(inviteCandidateResponse) {
  return {
    type: INVITE_CANDIDATE_SUCCESS,
    inviteCandidateResponse,
  };
}
export function inviteCandidateError(error) {
  return {
    type: INVITE_CANDIDATE_ERROR,
    data: error,
  };
}

export function deleteTestEvent(
  testEventIds,
  candidateId,
  currentStageId,
  jobDetailId,
  fromResultsV2
) {
  return {
    type: DELETE_TEST_EVENT,
    testEventIds,
    candidateId,
    currentStageId,
    jobDetailId,
    fromResultsV2,
  };
}
export function deleteTestEventSuccess(
  deleteTestEventResponse,
  candidateId,
  currentStageId,
  testEventIds,
  fromResultsV2
) {
  return {
    type: DELETE_TEST_EVENT_SUCCESS,
    deleteTestEventResponse,
    candidateId,
    currentStageId,
    testEventIds,
    fromResultsV2,
  };
}
export function deleteTestEventError(error) {
  return {
    type: DELETE_TEST_EVENT_ERROR,
    data: error,
  };
}

// release candidate scores
export function releaseScores(testEventId, candidateId, jobId, fromResultsV2) {
  return {
    type: RELEASE_SCORES,
    testEventId,
    candidateId,
    jobId,
    fromResultsV2,
  };
}
export function releaseScoresSuccess(candidate, candidateId, fromResultsV2) {
  return {
    type: RELEASE_SCORES_SUCCESS,
    candidate,
    candidateId,
    fromResultsV2,
  };
}
export function releaseScoresError(error) {
  return {
    type: RELEASE_SCORES_ERROR,
    data: error,
  };
}

// get all filters
export function getFilters() {
  return {
    type: GET_FILTERS,
  };
}
export function getFiltersSuccess(filtersResponse) {
  return {
    type: GET_FILTERS_SUCCESS,
    filtersResponse,
  };
}
export function getFiltersError() {
  return {
    type: GET_FILTERS_ERROR,
  };
}

// get checkr packages
export function getCheckrPackages() {
  return {
    type: GET_CHECKR_PACKAGES,
  };
}
export function getCheckrPackagesSuccess(packages) {
  return {
    type: GET_CHECKR_PACKAGES_SUCCESS,
    packages,
  };
}
export function getCheckrPackagesError() {
  return {
    type: GET_CHECKR_PACKAGES_ERROR,
  };
}

// invite candidate to checkr
export function checkrInviteCandidate(testTakerId, checkrPackage) {
  return {
    type: CHECKR_INVITE_CANDIDATE,
    testTakerId,
    checkrPackage,
  };
}
export function checkrInviteCandidateSuccess(checkrResponse, candidateId) {
  return {
    type: CHECKR_INVITE_CANDIDATE_SUCCESS,
    checkrResponse,
    candidateId,
  };
}
export function checkrInviteCandidateError() {
  return {
    type: CHECKR_INVITE_CANDIDATE_ERROR,
  };
}

// get company's checkr access token and credentialed flag
export function getCheckrInfo() {
  return {
    type: GET_CHECKR_INFO,
  };
}
export function getCheckrInfoSuccess(checkrInfo) {
  return {
    type: GET_CHECKR_INFO_SUCCESS,
    checkrInfo,
  };
}
export function getCheckrInfoError(err) {
  return {
    type: GET_CHECKR_INFO_ERROR,
    err,
  };
}

export function resetLoadedProps() {
  return {
    type: RESET_LOADED_PROPS,
  };
}

/* ---------- Set Candidate Found ----------- */

export function setCandidateFound() {
  return {
    type: SET_CANDIDATE_FOUND,
  };
}

/* ----------- Load TestMaker Tests ----------- */

export function loadTestMakerTests() {
  return {
    type: LOAD_TESTMAKER_TESTS,
  };
}
export function loadTestMakerTestsSuccess(data) {
  return {
    type: LOAD_TESTMAKER_TESTS_SUCCESS,
    data,
  };
}
export function loadTestMakerTestsError(err) {
  return {
    type: LOAD_TESTMAKER_TESTS_ERROR,
    err,
  };
}

/* ----------- Download Resume ------------ */

export function downloadResume(testTakerId) {
  return {
    type: DOWNLOAD_RESUME,
    testTakerId,
  };
}
export function downloadResumeSuccess() {
  return {
    type: DOWNLOAD_RESUME_SUCCESS,
  };
}
export function downloadResumeError(err) {
  return {
    type: DOWNLOAD_RESUME_ERROR,
    err,
  };
}

/* --------- Load Score Ranges ---------- */
export function loadScoreRanges() {
  return {
    type: LOAD_SCORE_RANGES,
  };
}

export function loadScoreRangesSuccess(data) {
  return {
    type: LOAD_SCORE_RANGES_SUCCESS,
    data,
  };
}

export function loadScoreRangesError(data) {
  return {
    type: LOAD_SCORE_RANGES_ERROR,
    data,
  };
}

/* ----------- Move candidate to new job ------------ */
export function moveCandidatesToJob(testTakerIds, jobId, currentJobDetailId) {
  return {
    type: MOVE_CANDIDATES_TO_JOB,
    testTakerIds,
    jobId,
    currentJobDetailId,
  };
}
export function moveCandidatesToJobSuccess(
  testTakerIds,
  jobId,
  currentJobDetailId
) {
  return {
    type: MOVE_CANDIDATES_TO_JOB_SUCCESS,
    testTakerIds,
    jobId,
    currentJobDetailId,
  };
}
export function moveCandidatesToJobError(err) {
  return {
    type: MOVE_CANDIDATES_TO_JOB_ERROR,
    err,
  };
}

/* ----------- Copy candidates to new job ------------ */
export function copyCandidatesToJob(testTakerIds, jobId, currentJobDetailId) {
  return {
    type: COPY_CANDIDATES_TO_JOB,
    testTakerIds,
    jobId,
    currentJobDetailId,
  };
}
export function copyCandidatesToJobSuccess(testTakerIds, jobId) {
  return {
    type: COPY_CANDIDATES_TO_JOB_SUCCESS,
    testTakerIds,
    jobId,
  };
}
export function copyCandidatesToJobError(err) {
  return {
    type: COPY_CANDIDATES_TO_JOB_ERROR,
    err,
  };
}

/* ----------- Make candidate private ------------ */
export function flipCandidatePrivacy(testTakerId, stageId) {
  return {
    type: FLIP_CANDIDATE_PRIVACY,
    testTakerId,
    stageId,
  };
}
export function flipCandidatePrivacySuccess(testTakerId, candidatePrivacy) {
  return {
    type: FLIP_CANDIDATE_PRIVACY_SUCCESS,
    testTakerId,
    candidatePrivacy,
  };
}
export function flipCandidatePrivacyError(err) {
  return {
    type: FLIP_CANDIDATE_PRIVACY_ERROR,
    err,
  };
}

/* --------- Get Pipeline By ID ---------- */

export function getPipelineById(pipelineId, jobId) {
  return {
    type: GET_PIPELINE_BY_ID,
    pipelineId,
    jobId,
  };
}

export function getPipelineByIdSuccess(
  pipeline,
  jobDetailId,
  hiredPipelineStageId
) {
  return {
    type: GET_PIPELINE_BY_ID_SUCCESS,
    pipeline,
    jobDetailId,
    hiredPipelineStageId,
  };
}

export function getPipelineByIdError(data) {
  return {
    type: GET_PIPELINE_BY_ID_ERROR,
    data,
  };
}

/* ---------- Delete document ---------- */

export function deleteDocument(testTakerId, documentName) {
  return {
    type: DELETE_DOCUMENT,
    data: {
      testTakerId,
      documentName,
    },
  };
}
export function deleteDocumentSuccess(testTakerId, documentName) {
  return {
    type: DELETE_DOCUMENT_SUCCESS,
    testTakerId,
    documentName,
  };
}
export function deleteDocumentError(err) {
  return {
    type: DELETE_DOCUMENT_ERROR,
    err,
  };
}
/* ---------- Upload document ---------- */

export function uploadDocument(testTakerId, documents) {
  return {
    type: UPLOAD_DOCUMENT,
    data: {
      testTakerId,
      documents,
    },
  };
}
export function uploadDocumentSuccess(testTakerId, document) {
  return {
    type: UPLOAD_DOCUMENT_SUCCESS,
    testTakerId,
    document,
  };
}
export function uploadDocumentError(err) {
  return {
    type: UPLOAD_DOCUMENT_ERROR,
    err,
  };
}

/* ---------- Get document link ---------- */

export function getDocumentLink(testTakerId, documentName, format) {
  return {
    type: GET_DOCUMENT_LINK,
    data: {
      testTakerId,
      documentName,
      download: format,
    },
  };
}
export function getDocumentLinkSuccess() {
  return {
    type: GET_DOCUMENT_LINK_SUCCESS,
  };
}
export function getDocumentLinkError(err) {
  return {
    type: GET_DOCUMENT_LINK_ERROR,
    err,
  };
}

/* ----------- Remind Candidate ----------- */
export function remindCandidate(emailTemplateId, testEventId, status = false) {
  return {
    type: REMIND_CANDIDATE,
    emailTemplateId,
    testEventId,
    status,
  };
}
export function remindCandidateSuccess() {
  return {
    type: REMIND_CANDIDATE_SUCCESS,
  };
}
export function remindCandidateError(error) {
  return {
    type: REMIND_CANDIDATE_ERROR,
    error,
  };
}

/* ----------- Delete Invitations ----------- */

export function deleteInvitations(
  testTakerIds,
  jobDetailId,
  pipelineStageIds,
  fromResultsV2
) {
  return {
    type: DELETE_INVITATIONS,
    testTakerIds,
    jobDetailId,
    pipelineStageIds,
    fromResultsV2,
  };
}
export function deleteInvitationsSuccess(
  deletedEvents,
  pipelineStageIds,
  fromResultsV2
) {
  return {
    type: DELETE_INVITATIONS_SUCCESS,
    deletedEvents,
    pipelineStageIds,
    fromResultsV2,
  };
}
export function deleteInvitationsError(error) {
  return {
    type: DELETE_INVITATIONS_ERROR,
    error,
  };
}

/* ----------- Get Workplace Insights Report ----------- */

export function getWorkplaceInsights(candidateId, testEventId, format) {
  return {
    type: GET_WORKPLACE_INSIGHTS,
    candidateId,
    testEventId,
    format,
  };
}
export function getWorkplaceInsightsSuccess(
  candidateId,
  testEventId,
  report,
  scores
) {
  return {
    type: GET_WORKPLACE_INSIGHTS_SUCCESS,
    candidateId,
    testEventId,
    report,
    scores,
  };
}
export function getWorkplaceInsightsError(error) {
  return {
    type: GET_WORKPLACE_INSIGHTS_ERROR,
    error,
  };
}

/* ----------- Clear Workplace Insights Report ----------- */

export function clearWorkplaceInsights() {
  return {
    type: CLEAR_WORKPLACE_INSIGHTS,
  };
}

/* ----------- Get Workplace Insights Email Preview ----------- */

export function getWorkplaceEmailPreview(testEventId) {
  return {
    type: GET_WORKPLACE_EMAIL_PREVIEW,
    testEventId,
  };
}

export function getWorkplaceEmailPreviewSuccess(response) {
  return {
    type: GET_WORKPLACE_EMAIL_PREVIEW_SUCCESS,
    response,
  };
}

export function getWorkplaceEmailPreviewError(error) {
  return {
    type: GET_WORKPLACE_EMAIL_PREVIEW_ERROR,
    error,
  };
}

/* ----------- Clear Workplace Insights Email Preview ----------- */

export function clearWorkplaceEmailPreview() {
  return {
    type: CLEAR_WORKPLACE_EMAIL_PREVIEW,
  };
}

/* ----------- Send Workplace Insights Email ----------- */

export function sendWorkplaceInsightsEmail(testEventId, testTakerName) {
  return {
    type: SEND_WORKPLACE_INSIGHTS_EMAIL,
    testEventId,
    testTakerName,
  };
}

export function sendWorkplaceInsightsEmailSuccess() {
  return {
    type: SEND_WORKPLACE_INSIGHTS_EMAIL_SUCCESS,
  };
}

export function sendWorkplaceInsightsEmailError(error) {
  return {
    type: SEND_WORKPLACE_INSIGHTS_EMAIL_ERROR,
    error,
  };
}

/* ----------- Get Manager Guide Report ----------- */
export function getManagerGuide(candidateId) {
  return {
    type: GET_MANAGER_GUIDE,
    candidateId,
  };
}

export function getManagerGuideSuccess(candidateId, managerGuideResponse) {
  return {
    type: GET_MANAGER_GUIDE_SUCCESS,
    candidateId,
    managerGuideResponse,
  };
}
export function getManagerGuideError(error) {
  return {
    type: GET_MANAGER_GUIDE_ERROR,
    error,
  };
}

/* ----------- Get Work Styles Report ----------- */

export function getWorkStyles(candidateId, testEventId, format) {
  return {
    type: GET_WORK_STYLES,
    candidateId,
    testEventId,
    format,
  };
}
export function getWorkStylesSuccess(
  candidateId,
  testEventId,
  report,
  scaledThetaScores
) {
  return {
    type: GET_WORK_STYLES_SUCCESS,
    candidateId,
    testEventId,
    report,
    scaledThetaScores,
  };
}
export function getWorkStylesError(error) {
  return {
    type: GET_WORK_STYLES_ERROR,
    error,
  };
}

/* ----------- Clear Work Styles Report ----------- */

export function clearWorkStyles() {
  return {
    type: CLEAR_WORK_STYLES,
  };
}

/* ----------- Get Individual Candidate ----------- */

export function getCandidateById(candidateId) {
  return {
    type: GET_CANDIDATE_BY_ID,
    candidateId,
  };
}
export function getCandidateByIdSuccess(candidateInfo) {
  return {
    type: GET_CANDIDATE_BY_ID_SUCCESS,
    candidateInfo,
  };
}
export function getCandidateByIdError(error) {
  return {
    type: GET_CANDIDATE_BY_ID_ERROR,
    error,
  };
}

/* ----------- Edit Candidate ----------- */

// TODO: fix default param last
export function editCandidate(
  testTakerId,
  stageId,
  candidateFormData,
  fromResultsV2
) {
  return {
    type: EDIT_CANDIDATE,
    testTakerId,
    stageId,
    candidateFormData,
    fromResultsV2,
  };
}

export function editCandidateSuccess(
  testTakerId,
  stageId,
  data,
  fromResultsV2
) {
  return {
    type: EDIT_CANDIDATE_SUCCESS,
    testTakerId,
    stageId,
    data,
    fromResultsV2,
  };
}

export function editCandidateError(error) {
  return {
    type: EDIT_CANDIDATE_ERROR,
    error,
  };
}

/* ----------- Extend Test Event Expiration ----------- */

export function extendEventExpiration(
  testEventIds,
  extendByDays,
  eventExpirationDate,
  candidateIds,
  currentStageId,
  currentCandidateId,
  fromResultsV2
) {
  return {
    type: EXTEND_EVENT_EXPIRATION,
    testEventIds,
    extendByDays,
    eventExpirationDate,
    candidateIds,
    currentStageId,
    currentCandidateId,
    fromResultsV2,
  };
}

export function extendEventExpirationSuccess(
  testEventIds,
  extendByDays,
  eventExpirationDate,
  candidateIds,
  currentStageId,
  fromResultsV2
) {
  return {
    type: EXTEND_EVENT_EXPIRATION_SUCCESS,
    testEventIds,
    extendByDays,
    eventExpirationDate,
    candidateIds,
    currentStageId,
    fromResultsV2,
  };
}

export function extendEventExpirationError(error) {
  return {
    type: EXTEND_EVENT_EXPIRATION_ERROR,
    error,
  };
}

/* ----------- Reset Candidate Summaries ----------- */

export function resetCandidateSummaries() {
  return {
    type: RESET_CANDIDATE_SUMMARIES,
  };
}

/* ----------- Update Candidate Counts After Candidate Delete Success ----------- */

export function updateCandidatesAfterDelete(
  currentStageId,
  currentCandidateId
) {
  return {
    type: UPDATE_CANDIDATES_AFTER_DELETE,
    currentStageId,
    currentCandidateId,
  };
}

/* ----------- Get Candidate Video Interview Results ----------- */

export function getVideoInterviewsResult(testTakerId) {
  return {
    type: GET_VIDEO_INTERVIEWS_RESULT,
    testTakerId,
  };
}

export function getVideoInterviewsResultSuccess(videoInterviewsResult) {
  return {
    type: GET_VIDEO_INTERVIEWS_RESULT_SUCCESS,
    videoInterviewsResult,
  };
}

export function getVideoInterviewsResultError(error) {
  return {
    type: GET_VIDEO_INTERVIEWS_RESULT_ERROR,
    error,
  };
}

/* ----------- Get Video Interview Templates ----------- */

export function getVideoInterviewTemplates() {
  return {
    type: GET_VIDEO_INTERVIEW_TEMPLATES,
  };
}
export function getVideoInterviewTemplatesSuccess(
  videoInterviewTemplatesResponse
) {
  return {
    type: GET_VIDEO_INTERVIEW_TEMPLATES_SUCCESS,
    videoInterviewTemplates: videoInterviewTemplatesResponse,
  };
}
export function getVideoInterviewTemplatesError(error) {
  return {
    type: GET_VIDEO_INTERVIEW_TEMPLATES_ERROR,
    data: error,
  };
}

/* ---------- Get Job By ID ---------- */

export function getJobById(jobDetailId) {
  return {
    type: GET_JOB_BY_ID,
    jobDetailId,
  };
}
export function getJobByIdSuccess(jobData) {
  return {
    type: GET_JOB_BY_ID_SUCCESS,
    jobData,
  };
}
export function getJobByIdError(err) {
  return {
    type: GET_JOB_BY_ID_ERROR,
    err,
  };
}

/* ---------- Reschedule video interview ---------- */

export function rescheduleVideoInterview(testTakerId, payload) {
  return {
    type: RESCHEDULE_VIDEO_INTERVIEW,
    testTakerId,
    payload,
  };
}
export function rescheduleVideoInterviewSuccess(
  rescheduleCandidatesResponse,
  testTakerId,
  externalIdOn
) {
  return {
    type: RESCHEDULE_VIDEO_INTERVIEW_SUCCESS,
    rescheduleCandidatesResponse,
    testTakerId,
    externalIdOn,
  };
}
export function rescheduleVideoInterviewError(err) {
  return {
    type: RESCHEDULE_VIDEO_INTERVIEW_ERROR,
    err,
  };
}

/* ---------- Change Sort Criteria ---------- */

export function changeSortCriteria(sortCriteria, currentStageId, columnSort) {
  return {
    type: CHANGE_SORT_CRITERIA,
    sortCriteria,
    currentStageId,
    columnSort,
  };
}

/* ---------- Get job results customization ---------- */

export function getJobResultsCustomization(userAccountId, jobDetailId) {
  return {
    type: GET_JOB_RESULTS_CUSTOMIZATION,
    userAccountId,
    jobDetailId,
  };
}
export function getJobResultsCustomizationSuccess(response) {
  return {
    type: GET_JOB_RESULTS_CUSTOMIZATION_SUCCESS,
    response,
  };
}
export function getJobResultsCustomizationError(err) {
  return {
    type: GET_JOB_RESULTS_CUSTOMIZATION_ERROR,
    err,
  };
}

/* ---------- Update job results customizations ---------- */

export function updateJobResultsCustomizations(
  userAccountId,
  jobDetailId,
  payload
) {
  return {
    type: UPDATE_JOB_RESULTS_CUSTOMIZATIONS,
    userAccountId,
    jobDetailId,
    payload,
  };
}
export function updateJobResultsCustomizationsSuccess() {
  return {
    type: UPDATE_JOB_RESULTS_CUSTOMIZATIONS_SUCCESS,
  };
}
export function updateJobResultsCustomizationsError(err) {
  return {
    type: UPDATE_JOB_RESULTS_CUSTOMIZATIONS_ERROR,
    err,
  };
}

// --------- Show Results v2 Bulk Action Modal ---------
export function showResultsV2BulkActionModal(show) {
  return {
    type: SHOW_RESULTS_V2_BULK_ACTION_MODAL,
    show,
  };
}

/* ---------- Revert results customizations ---------- */

export function revertResultsCustomizations(userAccountId, jobDetailId) {
  return {
    type: REVERT_RESULTS_CUSTOMIZATIONS,
    userAccountId,
    jobDetailId,
  };
}
export function revertResultsCustomizationsSuccess(response) {
  return {
    type: REVERT_RESULTS_CUSTOMIZATIONS_SUCCESS,
    response,
  };
}
export function revertResultsCustomizationsError(err) {
  return {
    type: REVERT_RESULTS_CUSTOMIZATIONS_ERROR,
    err,
  };
}

// --------- candidate structured interview score report ---------
export function getCandidateSIReport(candidateId, interviewType, interviewId) {
  return {
    type: GET_CANDIDATE_SI_REPORT,
    testTakerId: candidateId,
    interviewType,
    interviewId,
  };
}

export function getCandidateSIReportError(error) {
  return {
    type: GET_CANDIDATE_SI_REPORT_ERROR,
    error,
  };
}

// --------- Setting Current Stage Id ---------
export function setCurrentStageId(stageId) {
  return {
    type: SET_CURRENT_STAGE_ID,
    stageId,
  };
}

/* ----------- Reset Move Candidates Status ----------- */

export function resetMoveCandidatesStatus() {
  return {
    type: RESET_MOVE_CANDIDATES_STATUS,
  };
}

/* ----------- Get Candidate Live Interview Results ----------- */

export function getLiveInterviewsResult(testTakerId) {
  return {
    type: GET_LIVE_INTERVIEWS_RESULT,
    testTakerId,
  };
}

export function getLiveInterviewsResultSuccess(liveInterviewsResult) {
  return {
    type: GET_LIVE_INTERVIEWS_RESULT_SUCCESS,
    liveInterviewsResult,
  };
}

export function getLiveInterviewsResultError(error) {
  return {
    type: GET_LIVE_INTERVIEWS_RESULT_ERROR,
    error,
  };
}

/* ----------- Send Evaluators Email ----------- */

export function sendEvaluatorsEmail(formData, candidateId) {
  return {
    type: SEND_EVALUATORS_EMAIL,
    formData,
    candidateId,
  };
}

export function sendEvaluatorsEmailSuccess(candidateId, testEventIds) {
  return {
    type: SEND_EVALUATORS_EMAIL_SUCCESS,
    candidateId,
    testEventIds,
  };
}

export function sendEvaluatorsEmailError(candidateId, testEventIds) {
  return {
    type: SEND_EVALUATORS_EMAIL_ERROR,
    candidateId,
    testEventIds,
  };
}

/* ----------- Send Individual Evaluator Email ----------- */

export function sendIndividualEvaluatorEmail(formData) {
  return {
    type: SEND_INDIVIDUAL_EVALUATOR_EMAIL,
    formData,
  };
}

export function sendIndividualEvaluatorEmailSuccess(response) {
  return {
    type: SEND_INDIVIDUAL_EVALUATOR_EMAIL_SUCCESS,
    response,
  };
}

export function sendIndividualEvaluatorEmailError(err) {
  return {
    type: SEND_INDIVIDUAL_EVALUATOR_EMAIL_ERROR,
    err,
  };
}

/* ----------- Reset Send Evaluators Email ----------- */

export function resetSendEvaluatorsEmailStatus() {
  return {
    type: RESET_SEND_EVALUATORS_EMAIL_STATUS,
  };
}

/* --------- Get Dynamic Score Reports Data  ---------- */

export function getDynamicScoreReportsData(
  testEventId,
  testId,
  candidateId,
  format,
  reportType,
  testName,
  second
) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_DATA,
    testEventId,
    testId,
    candidateId,
    format,
    reportType,
    testName,
    second,
  };
}

export function getDynamicScoreReportsDataSuccess(
  dynamicScoreReportsData,
  testEventId,
  candidateId
) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS,
    dynamicScoreReportsData,
    testEventId,
    candidateId,
  };
}
export function getDynamicScoreReportsDataError(errorMsg) {
  return {
    type: GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR,
    errorMsg,
  };
}

export function resetDeleteTestEventSuccess() {
  return {
    type: RESET_DELETE_TEST_EVENT_SUCCESS,
  };
}

/* ---------- Remove merch banner ---------- */

export function removeMerchBanner(merchBannerOrigin) {
  return {
    type: REMOVE_MERCH_BANNER,
    merchBannerOrigin,
  };
}
export function removeMerchBannerSuccess() {
  return {
    type: REMOVE_MERCH_BANNER_SUCCESS,
  };
}
export function removeMerchBannerError(err) {
  return {
    type: REMOVE_MERCH_BANNER_ERROR,
    err,
  };
}

/* ---------- Move candidate to post hire ---------- */

// Payload Type:
// {
//   testTakerId: number
//   candidateStartDate: string
//   companyAccountEmail: string
//   sendEmailInvitation: 0 | 1 // If this is true, then we should send an email to the user/testTaker.
//   managerEmail: string (optional)
//   noteToManager: string (optional)
//   shareManagerGuide: 0 | 1
//   shareWorkplaceInsightReport: 0 | 1
//   shareLiveInterviewNotes: 0 | 1
//   shareVideoInterviewNotes: 0 | 1
//   shareResume: 0 | 1
//   shareCoverLetter: 0 | 1
// }
export function moveCandidateToPostHire(payload, modalOpenSource) {
  return {
    type: MOVE_CANDIDATE_TO_POST_HIRE,
    payload,
    modalOpenSource,
  };
}
export function moveCandidateToPostHireSuccess(payload) {
  return {
    type: MOVE_CANDIDATE_TO_POST_HIRE_SUCCESS,
    testTakerId: payload.testTakerId,
    createdUserAccountId: payload.createdUserAccountId,
  };
}
export function moveCandidateToPostHireError(err) {
  return {
    type: MOVE_CANDIDATE_TO_POST_HIRE_ERROR,
    err,
  };
}

export function resetMoveCandidateToPostHireStatus() {
  return {
    type: RESET_MOVE_CANDIDATE_TO_POST_HIRE_STATUS,
  };
}

/* ---------- Get post hire users ---------- */

export function getPostHireUsers() {
  return {
    type: GET_POST_HIRE_USERS,
  };
}
export function getPostHireUsersSuccess(postHireUsers) {
  return {
    type: GET_POST_HIRE_USERS_SUCCESS,
    postHireUsers,
  };
}
export function getPostHireUsersError(err) {
  return {
    type: GET_POST_HIRE_USERS_ERROR,
    err,
  };
}

/* ---------- Check for valid post hire email ---------- */

export function checkForValidPostHireEmail(emailAddress) {
  return {
    type: CHECK_FOR_VALID_POST_HIRE_EMAIL,
    emailAddress,
  };
}

export function checkForValidPostHireEmailSuccess(payload) {
  const { emailAddress, isValid, errorType, errorMessage } = payload;
  return {
    type: CHECK_FOR_VALID_POST_HIRE_EMAIL_SUCCESS,
    emailAddress,
    isValid,
    errorType,
    errorMessage,
  };
}

export function checkForValidPostHireEmailError(err) {
  return {
    type: CHECK_FOR_VALID_POST_HIRE_EMAIL_ERROR,
    err,
  };
}

/* ---------- Get post hire test takers ---------- */

export function getPostHireTestTakers() {
  return {
    type: GET_POST_HIRE_TEST_TAKERS,
  };
}
export function getPostHireTestTakersSuccess(response) {
  return {
    type: GET_POST_HIRE_TEST_TAKERS_SUCCESS,
    response,
  };
}
export function getPostHireTestTakersError(err) {
  return {
    type: GET_POST_HIRE_TEST_TAKERS_ERROR,
    err,
  };
}

/* ---------- Edit Video Interview Adjustments ---------- */

export function editVideoInterviewAdjustments(formData) {
  return {
    type: EDIT_VIDEO_INTERVIEW_ADJUSTMENTS,
    formData,
  };
}
export function editVideoInterviewAdjustmentsSuccess(
  updatedAdjustmentsResponse
) {
  return {
    type: EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_SUCCESS,
    updatedAdjustmentsResponse,
  };
}
export function editVideoInterviewAdjustmentsError(err) {
  return {
    type: EDIT_VIDEO_INTERVIEW_ADJUSTMENTS_ERROR,
    err,
  };
}

/* ---------- Get all posthire teams ---------- */

export function getAllPosthireTeams() {
  return {
    type: GET_ALL_POSTHIRE_TEAMS,
  };
}
export function getAllPosthireTeamsSuccess(response) {
  return {
    type: GET_ALL_POSTHIRE_TEAMS_SUCCESS,
    response,
  };
}
export function getAllPosthireTeamsError(err) {
  return {
    type: GET_ALL_POSTHIRE_TEAMS_ERROR,
    err,
  };
}
/* ---------- Get team personality scores by id ---------- */

export function getTeamPersonalityScoresById(teamId) {
  return {
    type: GET_TEAM_PERSONALITY_SCORES_BY_ID,
    teamId,
  };
}
export function getTeamPersonalityScoresByIdSuccess(teamId, response) {
  return {
    type: GET_TEAM_PERSONALITY_SCORES_BY_ID_SUCCESS,
    teamId,
    response,
  };
}
export function getTeamPersonalityScoresByIdError(err) {
  return {
    type: GET_TEAM_PERSONALITY_SCORES_BY_ID_ERROR,
    err,
  };
}

/* ---------- Get smart onboarding key insights ---------- */

export function getSmartOnboardingKeyInsights(teamId, testTakerId) {
  return {
    type: GET_SMART_ONBOARDING_KEY_INSIGHTS,
    teamId,
    testTakerId,
  };
}
export function getSmartOnboardingKeyInsightsSuccess(response) {
  return {
    type: GET_SMART_ONBOARDING_KEY_INSIGHTS_SUCCESS,
    response,
  };
}
export function getSmartOnboardingKeyInsightsError(err) {
  return {
    type: GET_SMART_ONBOARDING_KEY_INSIGHTS_ERROR,
    err,
  };
}

export function resetSmartOnboardingKeyInsights() {
  return {
    type: RESET_SMART_ONBOARDING_KEY_INSIGHTS,
  };
}
/* get Landing Page Data */
export function getLandingPageData(customLandingPageId) {
  return {
    type: GET_LANDING_PAGE,
    customLandingPageId,
  };
}
export function getLandingPageDataSuccess(customLandingPage) {
  return {
    type: GET_LANDING_PAGE_SUCCESS,
    customLandingPage,
  };
}
export function getLandingPageDataError(err) {
  return {
    type: GET_LANDING_PAGE_ERROR,
    err,
  };
}

// --------- get proctoring report ---------
export function getProctoringReport(testEventId, format, candidateId) {
  return {
    type: GET_PROCTORING_REPORT,
    testEventId,
    format,
    candidateId,
  };
}
export function getProctoringReportSuccess(
  candidateId,
  report,
  testEventTestId
) {
  return {
    type: GET_PROCTORING_REPORT_SUCCESS,
    data: { candidateId, report, testEventTestId },
  };
}
export function getProctoringReportError(error) {
  return {
    type: GET_PROCTORING_REPORT_ERROR,
    data: error,
  };
}

export function updateDownloadStatus(status) {
  return {
    type: UPDATE_DOWNLOAD_STATUS,
    status,
  };
}
